import store from '@/store';

const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Safety = () => import(/* webpackChunkName: "todo" */'@/components/pages/safety/All.vue');
const Work = () => import(/* webpackChunkName: "todo" */'@/components/pages/task/work/Alls.vue');
const Asset = () => import(/* webpackChunkName: "todo" */'@/components/pages/task/asset/Alls.vue');
const AssetDetail = () => import(/* webpackChunkName: "todo" */'@/components/pages/task/asset/AdminDetail.vue');
const Bug = () => import(/* webpackChunkName: "todo" */'@/components/pages/task/bug/Index.vue');
const TopMenu = () => import('@/components/pages/task/examine/index.vue');
const Score = () => import('@/components/pages/task/examine/Score.vue');
const Inventory = () => import('@/components/pages/task/examine/Inventory.vue');

const baseRouterMapping = {
  'EXAMINE_LIST': '/todo/examine/inventory',
  'EXAMINE_DEPT_DETAIL_QUERY': '/todo/examine/score',
};

export default [
  {
    path: '/event',
    name: '',
    component: Layout,
    meta: {
      roles: ['LOOPHOLE_RECTIFICATION_QUERY'],
    },
    children: [{
      path: '',
      name: 'event',
      component: Bug,
      meta: {
        roles: [],
        title: '安全事件',
        icon: 'event',
        activeMenu: '/event',
        componentName: 'Event',
        breadcrumb: [
          {
            name: '首页',
            path: '/home'
          },
          {
            name: '安全事件',
            path: '/event'
          }
        ]
      }
    }]
  },
  {
    path: '/todo',
    name: '',
    component: Layout,
    meta: {
      roles: ['SAFETY_QUERY', 'TASK_QUERY', 'ANNUAL_INSPECTION_QUERY', 'EXAMINE_LIST', 'EXAMINE_DEPT_DETAIL_QUERY'],
      title: '安全任务',
      icon: 'task',
    },
    children: [
      {
        path: 'safety',
        name: 'safety',
        component: Safety,
        meta: {
          roles: ['SAFETY_QUERY'],
          title: '报平安',
          activeMenu: '/todo',
          componentName: 'safety',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '安全任务',
              path: ''
            },
            {
              name: '报平安',
              path: '/todo/safety'
            }
          ]
        }
      },
      {
        path: 'work',
        name: 'todoWork',
        component: Work,
        meta: {
          roles: ['TASK_QUERY'],
          title: '安全工作',
          activeMenu: '/todo',
          componentName: 'todoWork',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '安全任务',
              path: ''
            },
            {
              name: '安全工作',
              path: '/todo/work'
            }
          ]
        }
      },
      {
        path: 'asset',
        name: 'todoAsset',
        component: Asset,
        meta: {
          roles: ['ANNUAL_INSPECTION_QUERY'],
          title: '年度审查',
          activeMenu: '/todo',
          componentName: 'todoAsset',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '安全任务',
              path: ''
            },
            {
              name: '年度审查',
              path: '/todo/asset'
            }
          ]
        }
      },
      {
        path: 'asset-detail/:id',
        name: 'todoAssetDetail',
        component: AssetDetail,
        meta: {
          hidden: true,
          roles: [],
          componentName: 'todoAssetDetail',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '安全任务',
              path: ''
            },
            {
              name: '年度审查',
              path: '/todo/asset'
            },
            {
              name: '任务详情',
              path: '',
              isActive: true
            }
          ]
        }
      },
      {
        path: 'examine',
        name: 'examine',
        redirect: () => {
          const roleIds = store.state.base.roleIds;
          let router = '/todo/examine/inventory';
          for (var item in baseRouterMapping) {
            if (roleIds.includes(item)) {
              router = baseRouterMapping[item];
              console.log(router);
              break;
            }
          }
          return router;
        },
        component: TopMenu,
        meta: {
          roles: ['EXAMINE_LIST', 'EXAMINE_DEPT_DETAIL_QUERY'],
          title: '安全考核',
        },
        children: [
          {
            path: 'inventory',
            name: 'inventory',
            meta: {
              roles: ['EXAMINE_LIST'],
              title: '考核清单',
              componentName: 'Inventory',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '安全任务',
                  path: ''
                },
                {
                  name: '安全考核',
                  path: ''
                },
                {
                  name: '考核清单',
                  path: '/todo/examine/inventory'
                }
              ]
            },
            component: Inventory
          },
          {
            path: 'score',
            name: 'score',
            meta: {
              roles: ['EXAMINE_DEPT_DETAIL_QUERY'],
              title: '考核得分',
              componentName: 'Score',
              breadcrumb: [
                {
                  name: '首页',
                  path: '/home'
                },
                {
                  name: '安全任务',
                  path: ''
                },
                {
                  name: '安全考核',
                  path: ''
                },
                {
                  name: '考核得分',
                  path: '/todo/examine/score'
                }
              ]
            },
            component: Score
          },
        ]
      },
      // {
      //   path: 'bug',
      //   name: 'todoBug',
      //   component: Bug,
      //   meta: {
      //     roles: ['LOOPHOLE_RECTIFICATION_QUERY'],
      //     title: '安全事件',
      //     activeMenu: '/todo',
      //     componentName: 'todoBug',
      //     breadcrumb: [
      //       {
      //         name: '首页',
      //         path: '/home'
      //       },
      //       {
      //         name: '安全任务',
      //         path: ''
      //       },
      //       {
      //         name: '安全事件',
      //         path: '/todo/bug'
      //       }
      //     ]
      //   }
      // },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/todo.js